import React, { useRef, useEffect, useState } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import Table, { ColumnsType } from "antd/lib/table";
import useGlobalModel from "@/model/globalModel";
import { useMonitoringModel } from "../monitoringModel";
import { message } from "antd";
import { purchasePoService } from "@/views/purchase/po/purchasePoService";
import { purchaseRoService } from "@/views/purchase/ro/purchaseRoService";
import { saleSoService } from "@/views/sale/so/saleSoService";
import { saleRoService } from "@/views/sale/ro/saleRoService";
import { formatNum } from "@/utils/utils";

//销售单结算
export function DetailsDrawer() {
	const { setLoadingInfo } = useGlobalModel();
	const {
		detailsVisible: { visible, code, type }, setDatailsVisible
	} = useMonitoringModel();
	const formRef = useRef<IYhFormRef>();
	const [formVal, setFormVal] = useState<any>({});
	const [list, setList] = useState<any[]>([]);

	useEffect(() => {
		if (visible && code) {
			getDetailOne(code)
		}
	}, [visible])

	const onCancel = () => {
		setDatailsVisible({ visible: false, code: "" });
	}

	const getDetailOne = async (code: string) => {
		setLoadingInfo({ loadingVisible: true, txt: "数据加载中..." });
		setFormVal({}); setList([]);
		try {
			let tempFn: any | undefined;
			switch (type) {
				case "io_spd":
					tempFn = purchasePoService.one;
					break;
				case "io_sprd":
					tempFn = purchaseRoService.one;
					break;
				case "io_ssd":
					tempFn = saleSoService.one;
					break;
				case "io_ssrd":
					tempFn = saleRoService.one;
					break;
				// case "io_usrd":
				// 	tempFn = saleIrregularService.one;
				// 	break;
				case "occupy_ssrd":
					tempFn = saleSoService.one;
					break;
				case "occupy_sprd":
					tempFn = purchaseRoService.one;
					break;
					// case "occupy_vam":
					// 	tempFn = appointmentService.one;
					// 	break;
					// case "occupy_vmm":
					// 	tempFn = maintenanceService.one;
					break;
				case "compensate":
					tempFn = purchasePoService.one;
					break;
				case "init":
					tempFn = purchasePoService.one;
					break;
				default:
					message.warning("查询异常");
					setLoadingInfo({ loadingVisible: false, txt: "" });
					return
			}
			const { retData: { details, materialDetails, ...from } } = await tempFn(code);
			setFormVal({
				...from,
				code,
				partner: from.customerName ?? from.supplierName
			});
			setList(details ?? materialDetails ?? [])
			setLoadingInfo({ loadingVisible: false, txt: "" });
		} catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
	}

	const formConfig: IYhForm = {
		formRef,
		formValues: formVal,
		labelCol: { span: 6 },
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "单据编号",
				fieldName: "code",
				span: 12,
				disable: true
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "单位名称",
				fieldName: "partner",
				span: 12,
				disable: true
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "制单员",
				fieldName: "createUser",
				span: 12,
				disable: true
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "库管员",
				fieldName: "storekeeper",
				span: 12,
				disable: true
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "制单时间",
				fieldName: "createTime",
				span: 12,
				disable: true
			}, {
				type: FormItemTypeEnum.Input,
				fieldLabel: "出入库时间",
				fieldName: "stockIoTime",
				span: 12,
				disable: true
			}
		]
	};


	const columns: ColumnsType<any> = [
		{
			title: '序号',
			fixed: "left",
			width: 60,
			align: "center",
			render: (t, r, i) => i + 1
		}, {
			title: '商品编码',
			width: 180,
			dataIndex: 'materialCode',
		}, {
			title: '商品名称',
			width: 160,
			dataIndex: 'materialName',
			render: (text: any) => <p className="ellipsis">{text}</p>,
		}, {
			title: '单价',
			width: 120,
			dataIndex: 'price',
			align: "right",
			render: (text: any) => `￥${formatNum(text)}`
		}, {
			title: '数量',
			width: 120,
			dataIndex: 'num',
			align: "right",
		}, {
			title: '金额',
			width: 120,
			dataIndex: 'amount',
			align: "right",
			render: (text: any, record: any) => `￥${formatNum(record.amount ?? record.materialAmount ?? record.num * record.price)}`
			// render: (text: any, record: any) => `￥${formatNum(record.num * record.price)}`
		},
		// {
		// 	title: '折扣金额',
		// 	width: 120,
		// 	dataIndex: 'discountRate',
		// 	align: "right",
		// 	render: (text: any, record: any) => `￥${formatNum(record.num * record.price * (1 - (text / 100)))}`
		// },
	];


	return (
		<YHDrawer
			{...{
				title: '单据明细查看',
				visible,
				onCancel,
				okText: "确认",
				width: 1000,
				onOk: onCancel
			}}
		>
			<YhForm {...formConfig} />
			<Table
				bordered
				rowKey={record => record.id as string}
				columns={columns}
				dataSource={list}
				pagination={false}
				scroll={{ x: 'max-content' }}
			/>
		</YHDrawer>
	)
}
